import React from 'react'
import Link from 'gatsby-link'
import './nextproject.css'


const NextProj = props => (
<div className="NextProj">
    <div className="NextProjGroup">
        <Link to={props.nextlink}>
            <h3>Next project</h3>
            <h2>{props.nextproj}</h2>
            <p>{props.projdesc}</p>
        </Link>
    </div>
</div>
)

export default NextProj